<template>
    <div class="add-event-type">
        <modal cross-btn="true" size-close-icon="md" size="40%" @close="$emit('close')">
            <div slot="modal-title">
                <h3>Add Company</h3>
            </div>
            <div slot="content">
                <div class="centered vue-loader" style="height: 350px" v-if="loading">
                    <vue-loader></vue-loader>
                </div>
                <div v-else class="form p-b-0-label">
                    <el-form ref="addEventType" :model="taxi_company" :rules="formRules" label-position="top"
                             class="newEventFormStyle">
                        <el-form-item label="Company name" prop="name">
                            <el-input v-model="taxi_company.name"></el-input>
                        </el-form-item>
                        <el-form-item label="Phone number" prop="phone_number">
                            <el-input v-model="taxi_company.phoneNumber"></el-input>
                        </el-form-item>
                        <el-form-item label="City" prop="City">
                            <el-select v-model="taxi_company.cityName" placeholder="Select city" style="width: 100%">
                                <el-option
                                        v-for="(city,index) in citys"
                                        :key="index"
                                        :label="city"
                                        :value="city">
                                </el-option>
                            </el-select>
                        </el-form-item>


                    </el-form>
                </div>
            </div>
            <div slot="modal-footer">
                <div class="footer-btn">
                    <el-button type="primary" size="small" @click="save('addEventType')">save</el-button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import {mapState} from 'vuex';
    import Modal from "@/common/components/Modal";
    import {LoaderIcon} from 'vue-feather-icons'
    import TaxiService from '@/common/services/taxi.service'

    export default {
        name: "EditTaxiCompany",
        components: {Modal, VueLoader: LoaderIcon},
        props:{taxi_company:Object},
        data() {
            return {
                loading: false,
                formRules: {
                    name: {
                        required: true,
                        trigger: 'change',
                    }
                },
                citys: [
                    'TETOVO', 'GOSTIVAR', 'SKOPJE', 'STRUGA']
            }
        },
        computed: {
            ...mapState({
                user_email: state => state.user.user_email,
            })
        },
        methods: {
            save(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.taxi_company.email = this.user_email;
                        TaxiService.updateTaxiCompany(this.taxi_company).then(() => {
                            this.$notify.success({
                                title: `Taxi`,
                                message: 'Successfully updated taxi company'
                            });
                            this.$emit('close')
                        }).catch(error => {
                            this.$notify.error({
                                title: `Failed to update taxi company`,
                                message: error.response.data.message
                            });
                        }).finally(() => this.loading = false)
                    } else {
                        return false;
                    }
                })
            },
        },beforeMount() {
            console.log(this.taxi_company)
        }
    }
</script>
<style scoped lang="scss">
    .add-event-type {
        h3 {
            margin: 0;
        }

        .form {
            height: 350px;

            .no-image-container {
                background-color: #f8f8f8;
                display: flex;
                width: 100%;
                height: 150px;
                cursor: pointer;

                .no-image-contents {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    flex-direction: column;
                    border-radius: 4px;
                }
            }

            .image-container {
                display: flex;
                justify-content: center;
                border: 1px solid #DCDFE6;
                border-radius: 4px;
                cursor: pointer;
            }

            .file-select {

            }

            .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }

            .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }

            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }

            .avatar {
                width: 178px;
                height: 178px;
                display: block;
            }

        }

        .footer-btn {
            display: flex;
            justify-content: flex-end;
        }

    }
</style>
